import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'adtiya-topheader',
  templateUrl: './topheader.component.html',
  styleUrls: ['./topheader.component.css']
})
export class TopheaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
